import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CommitBetslipButton from './commit-betslip-button.js';
import { noop } from 'mojito/utils';
import MojitoServices from 'mojito/services';

const { UIView } = MojitoCore.Presentation;
const { COMMIT_BETSLIP_MODE } = MojitoServices.Betslip.types;

/**
 * View for displaying the button that can be used for bet placement or save bet for future placement.
 *
 * @class CommitBetslipButton
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * CommitBetslipButton prop types.
 *
 * @property {Mojito.Services.Betslip.types.Calculation} [calculation = {}] - Betslip calculation.
 * @property {string} [currencyCode = ''] - Currency code to use in the button.
 * @property {boolean} [isSuspended = false] - Defines whether the button is suspended.
 * @property {boolean} [showTooltip = false] - If true then timed tooltip will be shown.
 * @property {Mojito.Services.Betslip.types.COMMIT_BETSLIP_MODE} [commitBetslipMode] - Commit betslip mode, indicating whether user can place a bet or save for later placement in a shop.
 * @property {string} [class] - The class name applied to the root element of the component.
 * @property {Mojito.Services.Betslip.types.BETSLIP_STATUS} [betslipStatus] - The current betslip status.
 * @property {boolean} [hasBetslipChanges = false] - Indicates the presence of non-accepted changes on betslip level, such as price or handicap changes.
 * @property {boolean} [disabled = false] - Determines if the button is disabled.
 * @property {Function} [onCommit = () => {}] - Callback triggered on betslip commit.
 * @property {Function} [onCloseTooltip = () => {}] - Callback triggered once tooltip is closed.
 * @property {Function} [onCommit = () => {}] - Callback triggered on betslip commit.
 * @property {string} [affiliateId] - Affiliate id. Typically, the id of the referrer user, will be used to present in a button additional info if available.
 * @memberof Mojito.Modules.BetslipView.CommitBetslipButton
 */
const propTypes = {
    calculation: PropTypes.object,
    currencyCode: PropTypes.string,
    isSuspended: PropTypes.bool,
    commitBetslipMode: PropTypes.string,
    betslipStatus: PropTypes.string,
    hasBetslipChanges: PropTypes.bool,
    disabled: PropTypes.bool,
    onCommit: PropTypes.func,
    onAcceptPriceChanges: PropTypes.func,
    onCloseTooltip: PropTypes.func,
    class: PropTypes.string,
    affiliateId: PropTypes.string,
    showTooltip: PropTypes.bool,
};

const defaultProps = {
    isSuspended: false,
    hasBetslipChanges: false,
    disabled: false,
    showTooltip: false,
    onCommit: noop,
    currencyCode: '',
    onAcceptPriceChanges: noop,
    onCloseTooltip: noop,
    class: 'ta-CommitBetslipButton',
    commitBetslipMode: COMMIT_BETSLIP_MODE.PLACE_BET,
    calculation: {},
};

export default UIView('CommitBetslipButton', CommitBetslipButton, propTypes, defaultProps);
